// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { GitCompareArrows as RawGitCompareArrows } from "lucide-react";
export const GitCompareArrows = /* @__PURE__ */ createIcon(RawGitCompareArrows, "GitCompareArrows", 2);
